import i18n from '../../../../utils/i18n';
import {
  IssueCriteria,
  MonitorApiPayload,
  Operator,
  OperatorType,
} from './types';

export const getDefaultCriteria = (): IssueCriteria => ({
  criteriaName: 'none',
  displayName: i18n.t('none'),
  required: false,
  allowedOperators: [],
});

export const affectedHoursOperatorOptions: OperatorType[] = [
  { display: '≥', key: '>=' },
  { display: '≤', key: '<=' },
];

export enum SubcriteriaEnum {
  Severity = 'Severity',
  Duration = 'Duration',
  AffectedHrs = 'Affected hrs',
  None = 'None',
}

export type IncludeExclude = 'include' | 'exclude';

export const incExcTogglerData: {
  key: IncludeExclude;
  label: string;
}[] = [
  {
    key: 'include',
    label: 'Include list',
  },
  {
    key: 'exclude',
    label: 'Exclude list',
  },
];

export const defaultMonitorApiPayload: MonitorApiPayload = {
  name: '',
  criteria: {
    sequence: '',
    criterias: {},
  },
  harvestSyncEnabled: false,
  locationAttributes: {
    operator: Operator.AND,
    filters: [],
  },
};
